import { render, staticRenderFns } from "./CharacteristicTeach.vue?vue&type=template&id=33e3206e&scoped=true"
import script from "./CharacteristicTeach.vue?vue&type=script&lang=js"
export * from "./CharacteristicTeach.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicTeach.vue?vue&type=style&index=0&id=33e3206e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e3206e",
  null
  
)

export default component.exports